var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentType,
    _vm._b(
      {
        tag: "component",
        class: [_vm.$style["mds-card"], _vm.classObject, _vm.sizeClass],
        attrs: { href: _vm.href, "data-mds-version": _vm.version },
      },
      "component",
      _vm.routingProps,
      false
    ),
    [
      _vm.label
        ? _c("div", { class: _vm.$style["mds-card__label"] }, [
            _c("div", { class: _vm.$style["mds-card__label-title"] }, [
              _vm._v(_vm._s(_vm.label)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.supplementalContentFirst && _vm.hasSupplementalSlotContent
        ? _c(
            "div",
            { class: _vm.$style["mds-card__supplemental-content"] },
            [_vm._t("mds-card-supplemental-content")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.headingType,
        { tag: "component", class: _vm.$style["mds-card__title"] },
        [
          _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.title))]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.caption
        ? _c("div", {
            class: _vm.$style["mds-card__caption"],
            domProps: { innerHTML: _vm._s(_vm.caption) },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.supplementalContentFirst && _vm.hasSupplementalSlotContent
        ? _c(
            "div",
            { class: _vm.$style["mds-card__supplemental-content"] },
            [_vm._t("mds-card-supplemental-content")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasActionSlotContent
        ? _c(
            "div",
            { class: _vm.$style["mds-card__action"] },
            [_vm._t("mds-card-action")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.metadata
        ? _c("div", {
            class: _vm.$style["mds-card__metadata"],
            domProps: { innerHTML: _vm._s(_vm.metadata) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }